<template>
  <div class="filter-custom">
    <td v-for="(item, index) in columns.fields" class="custom-filter-scroll" :key="index">
      <template v-if="item.key !== 'actions'">
        <b-form-group class="mb-0">
          <!-- text field -->
          <b-form-input class="table-filter-input" v-bind:class="item.tdClass ? item.tdClass : ''" type="text"  v-if="item.isFilter && filter[item.key] && filter[item.key].type == 'text'" @change="search" v-model="filter[item.key].value" placeholder="Search"></b-form-input>
          <!-- date field -->
          <b-button v-bind:class="item.tdClass ? item.tdClass : ''" v-if="item.isFilter && filter[item.key] && filter[item.key].type == 'date'" class="filter-search-date" @click="modalSearchDate(item.key)">Search</b-button>
          <!-- select field -->
          <multiselect v-model="value_collection[item.key]"
                       :options="dataSelect[item.key].value"
                       :multiple="true"
                       :close-on-select="false"
                       :clear-on-select="false"
                       placeholder="Search"
                       :label="dataSelect[item.key].text_field"
                       :track-by="dataSelect[item.key].text_field"
                       :internal-search="true"
                       :searchable="true"
                       tagPosition="bottom"
                       v-if="item.isFilter && filter[item.key] && filter[item.key].type == 'collection' && dataSelect != null &&  dataSelect.hasOwnProperty(item.key)"
                       @input="searchCollection(value_collection[item.key], 0, item.key, dataSelect[item.key].value_field)">
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} selected</span><span v-else>  </span></template>
          </multiselect>
          <!-- number field -->
          <b-button v-bind:class="item.tdClass ? item.tdClass : ''" v-if="item.isFilter && filter[item.key] && filter[item.key].type == 'number' && !filter[item.key].isPercent" class="filter-search-date" @click="modalSearchNumber(item.key)">{{filter[item.key].value ? filter[item.key].function + " " + filter[item.key].value : 'Search'}}</b-button>
          <b-button v-bind:class="item.tdClass ? item.tdClass : ''" v-if="item.isFilter && filter[item.key] && filter[item.key].type == 'number' && filter[item.key].isPercent" class="filter-search-date" @click="modalSearchPercent(item.key)">{{filter[item.key].value ? filter[item.key].function + " " + percent : 'Search'}}</b-button>
          <svg v-show="item.isFilter && filter[item.key] && ((filter[item.key].type != 'collection' && filter[item.key].value) || (value_collection[item.key] && value_collection[item.key].length > 0))" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" @click.stop="clearData(item.key)">
            <path d="M9.20047 1.04452C9.07591 0.911885 8.90681 0.837345 8.73047 0.837345C8.55412 0.837345 8.38502 0.911885 8.26047 1.04452L5.00047 4.50119L1.74047 1.03744C1.61591 0.904801 1.44681 0.830261 1.27047 0.830261C1.09412 0.830261 0.925023 0.904801 0.800469 1.03744C0.540469 1.31369 0.540469 1.75994 0.800469 2.03619L4.06047 5.49994L0.800469 8.96369C0.540469 9.23994 0.540469 9.68619 0.800469 9.96244C1.06047 10.2387 1.48047 10.2387 1.74047 9.96244L5.00047 6.49869L8.26047 9.96244C8.52047 10.2387 8.94047 10.2387 9.20047 9.96244C9.46047 9.68619 9.46047 9.23994 9.20047 8.96369L5.94047 5.49994L9.20047 2.03619C9.4538 1.76702 9.4538 1.31369 9.20047 1.04452Z" fill="black" fill-opacity="0.54"/>
          </svg>
        </b-form-group>
      </template>
    </td>
    <b-modal :no-close-on-backdrop="true" id="modal-FilterDate" :title="`Filter by ${title_modal}`" hide-footer :centered="true" ref="modal-FilterDate">
      <b-form class="pb-20" v-if="key_search_date">
        <b-row>
          <b-col md="12">
            <b-row>
              <template>
                <b-col md="6">
                	<gofix-form-input-date
                          v-model="$v.range.start_date.$model"
                          label="Start Date"
                          required>
                	</gofix-form-input-date>
                </b-col>
                <b-col md="6">
                  	<gofix-form-input-date
                          v-model="$v.range.end_date.$model"
                          label="End Date"
                          required>
                  	</gofix-form-input-date>
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
      </b-form>

      <b-button-group class="d-block text-right">
        <gofix-button label="RESET" @click="refresh('date')" noBorder dark></gofix-button>
        <gofix-button label="APPLY" @click="searchDateModal" noBorder></gofix-button>
      </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-FilterNumber" :title="`Filter by ${title_modal}`" hide-footer :centered="true" ref="modal-FilterNumber">
      <b-form class="pb-20" v-if="key_search_number">
        <b-row>
          <b-col md="12">
            <b-row>
              <template>
                <b-col md="6">
                  <gofix-form-input-number
                          label="Min"
                          v-model="$v.range_number.min.$model"
                          :include-thousands-separator="false"
                          required></gofix-form-input-number>
                </b-col>
                <b-col md="6">
                  <gofix-form-input-number
                          label="Max"
                          v-model="$v.range_number.max.$model"
                          :include-thousands-separator="false"
                          required></gofix-form-input-number>
                </b-col>
              </template>

            </b-row>
          </b-col>
        </b-row>
      </b-form>

      <b-button-group class="d-block text-right">
        <gofix-button label="RESET" @click="refresh('number')" noBorder dark></gofix-button>
        <gofix-button label="APPLY" @click="searchNumberModal" noBorder></gofix-button>
      </b-button-group>
    </b-modal>


    <b-modal :no-close-on-backdrop="true" id="modal-FilterPercent" :title="`Filter by ${title_modal}`" hide-footer :centered="true" ref="modal-FilterPercent">
      <b-form class="pb-20" v-if="key_search_percent">
        <b-row>
          <b-col md="12">
            <gofix-form-dropdown
                    label="Filter By"
                    vLabel="text"
                    :clearable="false"
                    :reduce="option => option.value"
                    :options="func_type.percentArray"
                    v-model="filter[key_search_percent].function"
            >
            </gofix-form-dropdown>
            <b-row>
              <b-col md="12">
				<template>
					<b-col md="6">
					<gofix-form-input-number
							label="Min"
							v-model="$v.range_percent.min.$model"
							:include-thousands-separator="false"
							required></gofix-form-input-number>
					</b-col>
					<b-col md="6">
					<gofix-form-input-number
							label="Max"
							v-model="$v.range_percent.max.$model"
							:include-thousands-separator="false"
							required></gofix-form-input-number>
					</b-col>
				</template>
				</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>

      <b-button-group class="d-block text-right">
        <gofix-button label="RESET" @click="refresh('percent')" noBorder dark></gofix-button>
        <gofix-button label="APPLY" @click="searchPercentModal" noBorder></gofix-button>
      </b-button-group>
    </b-modal>




  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import { func, val } from '@/_filterVar.js'

import moment from 'moment';
var accounting = require('accounting');

export default {
  name: 'filter-table',
  components: {
    Multiselect
  },
  props: {
    dataSelect: {
      type: Object,
      required: false,
      default: () => null
    },
    columns: {
      type: Object,
      required: true,
      default: () => []
    },
    filter: {
      type: Object,
      required: true,
      default: () => []
    },
    search: {
      type: Function,
      required: false
    }
  },
  data () {
    return {
      formats: {
        input: ['DD.MM.YYYY']
      },
      val_default: val,
      func_type: func,
      title_modal: '',
      /*filter type date*/
      key_search_date: null,
      range : {
        start_date: null,
        end_date: null
      },
      date: null,
      /*filter type number*/
      key_search_number: null,
      number: '',
      range_number : {
        min: '',
        max: ''
      },
       /*filter type percent*/
      key_search_percent: null,
      percent: '',
      range_percent : {
        min: '',
        max: ''
      },
      value_collection: {}
    }
  },
  mixins: [validationMixin],
  validations: {
    range: {
      start_date: {
        required
      },
      end_date: {
        required
      }
    },
    range_number: {
      min: {
        required
      },
      max: {
        required
      }
    },
    range_percent: {
      min: {
        required
      },
      max: {
        required
      }
    }
  },
  methods:{
    refresh(type) {
      if(type == 'number') {
        this.range_number.min = '0'
        this.range_number.max = '0'
        this.number = ''
        this.$nextTick(() => { this.$v.range_number.$reset() })
        if(this.key_search_number && this.filter[this.key_search_number]) {
          this.filter[this.key_search_number].value = []
        }
      }

      if(type == 'percent') {
        this.range_percent.min = '0'
        this.range_percent.max = '0'
        this.number = ''
        this.$nextTick(() => { this.$v.range_percent.$reset() })
        if(this.key_search_percent && this.filter[this.key_search_percent]) {
          this.filter[this.key_search_percent].value = []
        }
      }

      if(type == 'date') {
        this.range.start_date = null
        this.range.end_date = null
        this.date = null
        this.$nextTick(() => { this.$v.range.$reset() })
        if(this.key_search_date && this.filter[this.key_search_date]) {
          this.filter[this.key_search_date].value = []
        }
      }

      this.search();
    },
    modalSearchDate(key) {
	  this.key_search_date = key
      let obj = this.columns.fields.find(item => item.key == key)
      if(obj) {
        this.title_modal = obj.label
      }

      this.$nextTick(() => { this.$v.range.$reset() })
      if(this.key_search_date && this.filter[this.key_search_date]) {
        if(this.filter[this.key_search_date].function == '<>') {
          if(Array.isArray(this.filter[this.key_search_date].value) && this.filter[this.key_search_date].value.length > 0) {
            this.range.start_date = this.filter[this.key_search_date].value[0] ? new Date(this.filter[this.key_search_date].value[0]) : null;
            this.range.end_date = this.filter[this.key_search_date].value[1] ? new Date(this.filter[this.key_search_date].value[1]) : null;
          }
        }
        else if(this.filter[this.key_search_date].function == '<='){
            this.range.end_date = this.filter[this.key_search_date].value ? new Date(this.filter[this.key_search_date].value) : null;
        }
		else if(this.filter[this.key_search_date].function == '>='){
            this.range.start_date = this.filter[this.key_search_date].value ? new Date(this.filter[this.key_search_date].value) : null;
        }
      }

      this.$refs['modal-FilterDate'].show();
    },
    searchDateModal() {
	  	this.$nextTick(() => { this.$v.range.$reset() })
		if(this.key_search_date && this.filter[this.key_search_date]) {
			if(this.range.start_date && this.range.end_date){
				if(moment(this.range.start_date).isAfter(this.range.end_date)) {
					return this.$bvToast.toast("Start date must be less than end date", { title: `Notification`, autoHideDelay: 3000, variant: 'danger', solid: true })
				}
				this.filter[this.key_search_date].function = '<>';
				this.filter[this.key_search_date].value = [ this.range.start_date ? moment(new Date(this.range.start_date)).format('YYYY-MM-DD') : null, this.range.end_date ? moment(new Date(this.range.end_date)).format('YYYY-MM-DD') : null ]
				this.search();
				this.$refs['modal-FilterDate'].hide();
				return;
			}
			if(this.range.start_date && !this.range.end_date){
				this.filter[this.key_search_date].function = '>=';
				this.filter[this.key_search_date].value = this.range.start_date ? moment(new Date(this.range.start_date)).format('YYYY-MM-DD') : null
				this.search();
				this.$refs['modal-FilterDate'].hide();
				return;
			}
			if(!this.range.start_date && this.range.end_date){
				this.filter[this.key_search_date].function = '<=';
				this.filter[this.key_search_date].value = this.range.end_date ? moment(new Date(this.range.end_date)).format('YYYY-MM-DD') : null
				this.search();
				this.$refs['modal-FilterDate'].hide();
				return;
			}
		}
    },
    modalSearchNumber(key) {
	  this.key_search_number = key
      let obj = this.columns.fields.find(item => item.key == key)
      if(obj) {
        this.title_modal = obj.label
      }

      this.$nextTick(() => { this.$v.range_number.$reset() })
      if(this.key_search_number && this.filter[this.key_search_number]) {
        if(this.filter[this.key_search_number].function == '<>') {
          if(Array.isArray(this.filter[this.key_search_number].value) && this.filter[this.key_search_number].value.length > 0) {
            this.range_number.min = this.filter[this.key_search_number].value[0] ? this.filter[this.key_search_number].value[0] + '' : '0';
            this.range_number.max = this.filter[this.key_search_number].value[1] ? this.filter[this.key_search_number].value[1] + '' : '0';
          }
        }
		else if(this.filter[this.key_search_number].function == '<='){
            this.range_number.max = this.filter[this.key_search_number].value;
        }
		else if(this.filter[this.key_search_number].function == '>='){
            this.range_number.min = this.filter[this.key_search_number].value;
        }
      }
      this.$refs['modal-FilterNumber'].show();
    },
    modalSearchPercent(key) {
	  this.key_search_percent = key
      let obj = this.columns.fields.find(item => item.key == key)
      if(obj) {
        this.title_modal = obj.label
      }

      this.$nextTick(() => { this.$v.range_percent.$reset() })
      if(this.key_search_percent && this.filter[this.key_search_percent]) {
        if(this.filter[this.key_search_percent].function == '<>') {
          if(Array.isArray(this.filter[this.key_search_percent].value) && this.filter[this.key_search_percent].value.length > 0) {
            this.range_percent.min = this.filter[this.key_search_percent].value[0] ? this.filter[this.key_search_percent].value[0] * 100 + '' : '0';
            this.range_percent.max = this.filter[this.key_search_percent].value[1] ? this.filter[this.key_search_percent].value[1] * 100 + '' : '0';
          }
        }
		else if(this.filter[this.key_search_percent].function == '<='){
            this.range_percent.max = this.filter[this.key_search_percent].value*100;
        }
		else if(this.filter[this.key_search_percent].function == '>='){
            this.range_percent.min = this.filter[this.key_search_percent].value*100;
        }
      }
      this.$refs['modal-FilterPercent'].show();
    },
    searchNumberModal() {
		this.$nextTick(() => { this.$v.range_number.$reset() })
		if(this.key_search_number && this.filter[this.key_search_number]) {
			if(this.range_number.min && this.range_number.max){
				if(Number(accounting.unformat(this.range_number.min)) > Number(accounting.unformat(this.range_number.max))) {
					return this.$bvToast.toast("'Max' must be greater than 'min'", { title: `Notification`, autoHideDelay: 3000, variant: 'danger', solid: true })
				}
				this.filter[this.key_search_number].function = '<>';
				this.filter[this.key_search_number].value = [ Number(accounting.unformat(this.range_number.min)), Number(accounting.unformat(this.range_number.max)) ]
				this.search();
				this.$refs['modal-FilterNumber'].hide();
				return;
			}
			if(this.range_number.min && !this.range_number.max){
				this.filter[this.key_search_number].function = '>=';
				this.filter[this.key_search_number].value = Number(accounting.unformat(this.range_number.min))
				this.search();
				this.$refs['modal-FilterNumber'].hide();
				return;
			}
			if(!this.range_number.min && this.range_number.max){
				this.filter[this.key_search_number].function = '<=';
				this.filter[this.key_search_number].value = Number(accounting.unformat(this.range_number.max))
				this.search();
				this.$refs['modal-FilterNumber'].hide();
				return;
			}
		}
    },
    searchPercentModal() {
		this.$nextTick(() => { this.$v.range_percent.$reset() })
		if(this.key_search_percent && this.filter[this.key_search_percent]) {
			if(this.range_percent.min && this.range_percent.max){
				if(Number(accounting.unformat(this.range_percent.min)) > Number(accounting.unformat(this.range_percent.max))) {
					return this.$bvToast.toast("'Max' must be greater than 'min'", { title: `Notification`, autoHideDelay: 3000, variant: 'danger', solid: true })
				}
				this.filter[this.key_search_percent].function = '<>';
				this.filter[this.key_search_percent].value = [ Number(accounting.unformat(this.range_percent.min))/100, Number(accounting.unformat(this.range_percent.max))/100 ]
				this.search();
				this.$refs['modal-FilterNumber'].hide();
				return;
			}
			if(this.range_percent.min && !this.range_percent.max){
				this.filter[this.key_search_percent].function = '>=';
				this.filter[this.key_search_percent].value = Number(accounting.unformat(this.range_percent.min))/100
				this.search();
				this.$refs['modal-FilterNumber'].hide();
				return;
			}
			if(!this.range_percent.min && this.range_percent.max){
				this.filter[this.key_search_percent].function = '<=';
				this.filter[this.key_search_percent].value = Number(accounting.unformat(this.range_percent.max))/100
				this.search();
				this.$refs['modal-FilterPercent'].hide();
				return;
			}
		}
    },
    clearData(key) {
      if(this.filter[key]) {
        this.filter[key].value = ''
        if(this.filter[key].type == 'date') {
          this.filter[key].value = this.val_default.date
        }
        if(this.filter[key].type == 'collection') {
          this.filter[key].value = this.val_default.collection
          if(this.value_collection[key]) {
            this.value_collection[key] = []
          }
        }
        this.search()
      }
    },
    searchCollection(value, id, key_search, key_value) {
      this.filter[key_search].value = []
      if(value && value.length > 0) {
        this.filter[key_search].value = value.map(item => {
          return item[key_value];
        })
      }
      this.search();
    }
  }
}
</script>
